import Vue from "vue"

Vue.filter("numberFormat", (value) => {
  return Number(value).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
})
Vue.filter("discountDetailHtml", (value) => {
  if(value.length >= 6){
    return "<p style='padding-left:10px;'>("+value+")</p>"
  }
  return "<span>("+value+")</span>"
})